// inspired by https://github.com/vercel/next.js/discussions/36723#discussioncomment-5186972

import { useRouter } from "next/navigation";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { create } from "zustand";

interface HistoryStoreType {
  history: string[];
}

const historyStore = create<HistoryStoreType>((set) => ({
  history: [],
}));

/** use as a hook to get prevAsPath and currentAsPath*/
export const useHistory = () => {
  return historyStore((state) => state);
};

/** use everywhere you like */
export const getHistory = () => {
  return historyStore.getState();
};

/** Only use this in _app.tsx or root it's like a Provider */
export const useHistoryInitializer = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const { history } = getHistory();

    if (
      window.location.href &&
      (history.length === 0 || history[history.length - 1] !== window.location.href)
    ) {
      historyStore.setState((state) => ({
        ...state,
        history: [...state.history.slice(-10), window.location.href],
      }));
    }
  }, [pathname, searchParams]);
};
